import React from 'react'
import {Button} from "@material-ui/core";

import {UploadResumeButton} from "components/UploadResumeButton";

import {
  PopupTitle,
  PopupContainer,
  PopupDescription,
  PopupButtonsContainer
} from "../HygienistJobDetails.styles";

interface NoResumeActionsProps {
  onResumeUploaded: () => Promise<void>
  onCancel: () => void
}

const NoResumeActions = ({
  onResumeUploaded,
  onCancel,
}: NoResumeActionsProps) => {
  return (
    <PopupContainer>
      <PopupTitle>You need to upload a Resumé</PopupTitle>
      <PopupDescription>
        You’ll need a Resumé to apply for this job. Upload it now?
      </PopupDescription>
      <PopupButtonsContainer>
        <Button
          variant="outlined"
          onClick={onCancel}
          color="primary"
          size="large"
          id="review-button"
          className="bigButtonInNewStyle"
        >
          Cancel
        </Button>
      </PopupButtonsContainer>
      <UploadResumeButton onResumeUploaded={onResumeUploaded} />
    </PopupContainer>
  )
}

export default NoResumeActions;
